export const NODE_W = 210;
export const NODE_H = 78;
const uid = (p) => `${p}_${Math.random().toString(36).slice(2, 10)}`;

export const STEP_TYPES = {
  agent: { label: "Agent", color: "#D4FF3A", hint: "An atlas operator does the work" },
  approval: { label: "Human approval", color: "#FFB020", hint: "Pause until someone approves on the desk" },
  condition: { label: "Condition", color: "#00E5FF", hint: "Ask Jev about the last receipt, or check confidence — unsure goes to a human" },
  delay: { label: "Delay", color: "#9A9AAE", hint: "Wait a few seconds before continuing" },
};

export function newNode(type, x, y, agent) {
  const base = { id: uid("n"), type, x: Math.round(x), y: Math.round(y), agent_slug: null, label: "", config: {} };
  if (type === "agent") return { ...base, agent_slug: agent?.slug || null, label: agent?.name || "Choose an agent" };
  if (type === "approval") return { ...base, label: "Manager sign-off" };
  if (type === "condition") return { ...base, label: "If confidence < 70%", config: { threshold: 70 } };
  return { ...base, label: "Wait 5s", config: { seconds: 5 } };
}

export const newEdge = (source, target) => ({ id: uid("e"), source, target });

export function orderNodes(nodes, edges) {
  const byId = Object.fromEntries(nodes.map((n) => [n.id, n]));
  const incoming = new Set(edges.map((e) => e.target));
  const next = Object.fromEntries(edges.map((e) => [e.source, e.target]));
  const starts = nodes.filter((n) => !incoming.has(n.id) && next[n.id]).sort((a, b) => a.x - b.x);
  if (!starts.length) return [...nodes].sort((a, b) => a.x - b.x);
  const out = [];
  let cur = starts[0].id;
  while (cur && byId[cur] && !out.find((n) => n.id === cur)) {
    out.push(byId[cur]);
    cur = next[cur];
  }
  return [...out, ...nodes.filter((n) => !out.includes(n))];
}

export function linearize(list) {
  const nodes = list.map((n, i) => ({ ...n, x: 40 + i * 250, y: 140 }));
  return { nodes, edges: nodes.slice(1).map((n, i) => newEdge(nodes[i].id, n.id)) };
}

export const STATE_COLOR = { running: "#D4FF3A", done: "#D4FF3A", passed: "#00E5FF", waiting: "#FFB020", rejected: "#FF3B5C", failed: "#FF3B5C", pending: "rgba(255,255,255,0.12)" };
